/* =============================================================================
 * Delta Clothing — Shopify <-> Dash cart bridge
 *
 * Replaces window.Shopify.{addItem, getCart, removeItem, changeItem, clearCart}
 * with thin wrappers that hit dash.deltaclothing.com.
 * ============================================================================= */
(function () {
  if (!window.B2B || window.__dlc_bridge_installed) return;
  window.__dlc_bridge_installed = true;

  var B2B = window.B2B;
  var cartAdd = window.DLC && window.DLC.cartAdd;

  function readPdpSelection(anchor) {
    if (cartAdd) {
      return cartAdd.readProperties(cartAdd.findRoot(anchor || document));
    }
    return {};
  }

  function addItemViaPanel(variant_id, quantity, $target, callback, input) {
    if (cartAdd) {
      var props = {};
      if (input && input.properties && typeof input.properties === 'object') {
        props = input.properties;
      }
      return cartAdd
        .postAdd({
          variantId: variant_id,
          quantity: quantity,
          properties: props,
          root: $target || document,
        })
        .then(function (resp) {
          try {
            if (typeof callback === 'function') callback(resp);
          } catch (e) {}
          return resp;
        });
    }

    var cust = B2B.getCustomerGid();
    if (!cust) {
      window.location.href = '/account/login';
      return;
    }
    var props = readPdpSelection($target);
    if (input && input.properties && typeof input.properties === 'object') {
      Object.keys(input.properties).forEach(function (k) {
        var v = input.properties[k];
        if (v !== undefined && v !== null && v !== '') props[k] = String(v);
      });
    }
    return fetch(B2B.endpoints.coupon, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: cust,
        items: [{
          variant_id: 'gid://shopify/ProductVariant/' + String(variant_id).replace(/\D/g, ''),
          quantity: parseInt(quantity, 10) || 1,
          price: 0,
          properties: props,
        }],
      }),
      keepalive: true,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        try {
          if (typeof callback === 'function') callback(resp);
        } catch (e) {}
        try {
          if (typeof window.setBagCountFromResponse === 'function') {
            window.setBagCountFromResponse(resp);
          }
        } catch (e) {}
        try {
          window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: resp }));
        } catch (e) {}
        return resp;
      })
      .catch(function (err) {
        console.error('[dlc] addItem failed', err);
      });
  }

  function getCartViaPanel(callback) {
    var cust = B2B.getCustomerGid();
    if (!cust) {
      if (typeof callback === 'function') callback({ items: [], item_count: 0, total_price: 0, currency: 'USD' });
      return;
    }
    fetch(B2B.endpoints.bag, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cust }),
      cache: 'no-store',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (lines) {
        var arr = Array.isArray(lines) ? lines : [];
        var items = arr.map(function (l) {
          return {
            id: l.variant_id || l.line_id,
            variant_id: l.variant_id,
            line_id: l.line_id,
            quantity: parseInt(l.quantity, 10) || 0,
            price: Math.round((parseFloat(l.price) || 0) * 100),
            line_price: Math.round(((parseFloat(l.price) || 0) * (parseInt(l.quantity, 10) || 0)) * 100),
            title: l.title || '',
            product_title: l.title || '',
            variant_title: (l.custom && (l.custom.Variant || l.custom.Color)) || '',
            properties: l.custom || {},
            sku: l.sku || '',
          };
        });
        var total = items.reduce(function (s, it) {
          return s + it.line_price;
        }, 0);
        var cart = {
          items: items,
          item_count: items.reduce(function (s, it) {
            return s + it.quantity;
          }, 0),
          total_price: total,
          currency: 'USD',
        };
        if (typeof callback === 'function') callback(cart);
        return cart;
      })
      .catch(function () {
        if (typeof callback === 'function') callback({ items: [], item_count: 0, total_price: 0, currency: 'USD' });
      });
  }

  function removeItemViaPanel(lineId, callback) {
    var cust = B2B.getCustomerGid();
    if (!cust) return;
    return fetch(B2B.endpoints.remove, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cust, lineId: lineId }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        try {
          if (typeof window.setBagCountFromResponse === 'function') window.setBagCountFromResponse(resp);
        } catch (e) {}
        try {
          window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: resp }));
        } catch (e) {}
        if (typeof callback === 'function') callback(resp);
        return resp;
      });
  }

  function clearCartViaPanel(callback) {
    var cust = B2B.getCustomerGid();
    if (!cust) return;
    return fetch(B2B.endpoints.clear, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cust }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        try {
          if (typeof window.setBagCountFromResponse === 'function') window.setBagCountFromResponse(resp);
        } catch (e) {}
        try {
          window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: resp }));
        } catch (e) {}
        if (typeof callback === 'function') callback(resp);
        return resp;
      });
  }

  if (window.Shopify) {
    window.Shopify.addItem = addItemViaPanel;
    window.Shopify.getCart = getCartViaPanel;
    window.Shopify.removeItem = removeItemViaPanel;
    window.Shopify.changeItem = function (line, qty, cb) {
      console.warn('[dlc] changeItem — use panel cart UI');
      if (typeof cb === 'function') cb();
    };
    window.Shopify.clearCart = clearCartViaPanel;
  }
})();
